(function () {
  let screenSize = window.innerWidth;
  ("use strict");
  if (innerWidth > 991) {
    function Slider() {
      this.cards = document.querySelectorAll(".parallax-horizontal .card");
      this.currentIndex = 0;
      this.cardsPerView = 3;
      this.cardWidth = 375;
      this.paddingLeft = 100;
      this.cardGap = 20;

      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.initEvents();
      this.setActivePlaceholder();
    }

    Slider.prototype.initEvents = function () {
      const container = document.querySelector(".parallax-horizontal");

      container.addEventListener("touchstart", this.onStart.bind(this));
      container.addEventListener("touchmove", this.onMove.bind(this));
      container.addEventListener("touchend", this.onEnd.bind(this));

      container.addEventListener("mousedown", this.onStart.bind(this));
      container.addEventListener("mousemove", this.onMove.bind(this));
      container.addEventListener("mouseup", this.onEnd.bind(this));
    };

    Slider.prototype.setActivePlaceholder = function () {
      var placeholders = document.querySelectorAll(".cards-placeholder__item");
      var activePlaceholder = document.querySelector(".cards-placeholder__item--active");

      if (activePlaceholder) {
        activePlaceholder.classList.remove("cards-placeholder__item--active");
      }

      placeholders[Math.floor(this.currentIndex / this.cardsPerView)].classList.add("cards-placeholder__item--active");
    };

    Slider.prototype.onStart = function (evt) {
      this.isDragging = true;

      this.currentX = evt.pageX || evt.touches[0].pageX;
      this.startX = this.currentX;
      this.paddingLeft;
      this.wrapperWidth =
        this.cardWidth * this.cardsPerView + this.paddingLeft + this.cardGap * (this.cardsPerView - 1); // Total width for visible cards + padding + gaps
    };

    Slider.prototype.onEnd = function (evt) {
      this.isDragging = false;

      var diff = this.startX - this.currentX;
      var direction = diff > 0 ? "left" : "right";
      this.startX = 0;

      if (Math.abs(diff) > this.wrapperWidth / 3) {
        if (direction === "left") {
          this.slideLeft();
        } else if (direction === "right") {
          this.slideRight();
        } else {
          this.cancelMoveCard();
        }
      } else {
        this.cancelMoveCard();
      }
    };

    Slider.prototype.onMove = function (evt) {
      if (!this.isDragging) return;

      this.currentX = evt.pageX || evt.touches[0].pageX;
      var diff = this.startX - this.currentX;
      diff *= -1;

      if (Math.abs(diff) > this.wrapperWidth / 5) {
        if (diff > 0) {
          diff = this.wrapperWidth / 5;
        } else {
          diff = -this.wrapperWidth / 5;
        }
      }

      this.moveCard(diff);
    };

    Slider.prototype.slideLeft = function () {
      if (this.currentIndex >= this.cards.length - this.cardsPerView) {
        this.cancelMoveCard();
        return;
      }

      var self = this;
      var cardWidthWithGap = this.cardWidth + this.cardGap;

      this.cards.forEach((card, index) => {
        card.style.transition = "transform 0.5s ease-out";
        card.style.transform = `translateX(-${(this.currentIndex + 1) * cardWidthWithGap}px)`;
      });

      this.currentIndex += 1;
      this.setActivePlaceholder();

      setTimeout(function () {
        self.cards.forEach((card) => {
          card.style.transition = "";
        });
      }, 500);
    };

    Slider.prototype.slideRight = function () {
      if (this.currentIndex === 0) {
        this.cancelMoveCard();
        return;
      }

      var self = this;
      var cardWidthWithGap = this.cardWidth + this.cardGap;

      this.cards.forEach((card, index) => {
        card.style.transition = "transform 0.5s ease-out";
        card.style.transform = `translateX(-${(this.currentIndex - 1) * cardWidthWithGap}px)`;
      });

      this.currentIndex -= 1;

      setTimeout(function () {
        self.cards.forEach((card) => {
          card.style.transition = "";
        });
      }, 500);
    };

    Slider.prototype.cancelMoveCard = function () {
      var self = this;
      this.cards.forEach((card) => {
        card.style.transition = "transform 0.5s ease-out";
        card.style.transform = `translateX(-${this.currentIndex * (this.cardWidth + this.cardGap)}px)`;
      });

      setTimeout(function () {
        self.cards.forEach((card) => {
          card.style.transition = "";
        });
      }, 500);
    };

    Slider.prototype.moveCard = function (diff) {
      this.cards.forEach((card) => {
        card.style.transform = `translateX(calc(${diff}px - ${this.currentIndex * (this.cardWidth + this.cardGap)}px))`;
      });
    };

    var slider = new Slider();
  } else {
    function Slider() {
      this.cards = document.querySelectorAll(".parallax-horizontal .card");
      this.currentIndex = 0;

      this.isDragging = false;
      this.startX = 0;
      this.currentX = 0;

      this.initEvents();
      this.setActivePlaceholder();
    }

    Slider.prototype.initEvents = function () {
      document.addEventListener("touchstart", this.onStart.bind(this));
      document.addEventListener("touchmove", this.onMove.bind(this));
      document.addEventListener("touchend", this.onEnd.bind(this));

      document.addEventListener("mousedown", this.onStart.bind(this));
      document.addEventListener("mousemove", this.onMove.bind(this));
      document.addEventListener("mouseup", this.onEnd.bind(this));
    };

    Slider.prototype.setActivePlaceholder = function () {
      var placeholders = document.querySelectorAll(".cards-placeholder__item");
      var activePlaceholder = document.querySelector(".cards-placeholder__item--active");

      if (activePlaceholder) {
        activePlaceholder.classList.remove("cards-placeholder__item--active");
      }

      placeholders[this.currentIndex].classList.add("cards-placeholder__item--active");
    };

    Slider.prototype.onStart = function (evt) {
      this.isDragging = true;

      this.currentX = evt.pageX || evt.touches[0].pageX;
      this.startX = this.currentX;

      var card = this.cards[this.currentIndex];

      this.windowWidth = window.innerWidth;
      this.cardWidth = card.offsetWidth;
      this.ratio = this.windowWidth / (this.cardWidth / 4);
    };

    Slider.prototype.onEnd = function (evt) {
      this.isDragging = false;

      var diff = this.startX - this.currentX;
      var direction = diff > 0 ? "left" : "right";
      this.startX = 0;

      if (Math.abs(diff) > this.windowWidth / 4) {
        if (direction === "left") {
          this.slideLeft();
        } else if (direction === "right") {
          this.slideRight();
        } else {
          this.cancelMoveCard();
        }
      } else {
        this.cancelMoveCard();
      }
    };

    Slider.prototype.onMove = function (evt) {
      if (!this.isDragging) return;

      this.currentX = evt.pageX || evt.touches[0].pageX;
      var diff = this.startX - this.currentX;
      diff *= -1;
      if (Math.abs(diff) > this.windowWidth / 4) {
        if (diff > 0) {
          diff = this.windowWidth / 4;
        } else {
          diff = -this.windowWidth / 4;
        }
      }

      this.moveCard(diff);
    };

    Slider.prototype.slideLeft = function () {
      if (this.currentIndex === this.cards.length - 1) {
        this.cancelMoveCard();
        return;
      }

      var self = this;
      var card = this.cards[this.currentIndex];
      var cardWidth = this.windowWidth / 2;

      card.style.left = "-50%";

      this.resetCardElsPosition();

      this.currentIndex += 1;
      this.setActivePlaceholder();
      card = this.cards[this.currentIndex];

      card.style.left = "50%";

      this.moveCardEls(cardWidth * 3);

      setTimeout(function () {
        self.resetCardElsPosition();
      }, 50);
    };

    Slider.prototype.slideRight = function () {
      if (this.currentIndex === 0) {
        this.cancelMoveCard();
        return;
      }

      var self = this;
      var card = this.cards[this.currentIndex];
      var cardWidth = this.windowWidth / 2;

      card.style.left = "150%";

      this.resetCardElsPosition();

      this.currentIndex -= 1;
      this.setActivePlaceholder();
      card = this.cards[this.currentIndex];

      card.style.left = "50%";

      this.moveCardEls(-cardWidth * 3);

      setTimeout(function () {
        self.resetCardElsPosition();
      }, 50);
    };

    Slider.prototype.cancelMoveCard = function () {
      var self = this;
      var card = this.cards[this.currentIndex];

      card.style.transition = "transform 0.5s ease-out";
      card.style.transform = "";

      this.resetCardElsPosition();
    };

    Slider.prototype.resetCardElsPosition = function () {
      var self = this;
      var card = this.cards[this.currentIndex];
      var cardTitle = card.querySelector(".card__title");
      var cardSubtitle = card.querySelector(".card__subtitle");
      var cardImage = card.querySelector(".card__image");
      var cardWillAnimate = card.querySelectorAll(".card__will-animate");

      cardWillAnimate.forEach(function (el) {
        el.style.transition = "transform 0.5s ease-out";
      });
      cardTitle.style.transform = "";
      cardSubtitle.style.transform = "";
      cardImage.style.transform = "";

      setTimeout(function () {
        card.style.transform = "";
        card.style.transition = "";

        cardWillAnimate.forEach(function (el) {
          el.style.transition = "";
        });
      }, 500);
    };

    Slider.prototype.moveCard = function (diff) {
      var card = this.cards[this.currentIndex];

      card.style.transform = "translateX(calc(" + diff + "px - 50%))";
      diff *= -1;

      this.moveCardEls(diff);
    };

    Slider.prototype.moveCardEls = function (diff) {
      var card = this.cards[this.currentIndex];
      var cardTitle = card.querySelector(".card__title");
      var cardSubtitle = card.querySelector(".card__subtitle");
      var cardImage = card.querySelector(".card__image");

      cardTitle.style.transform = "translateX(" + diff / (this.ratio * 0.9) + "px)";
      cardSubtitle.style.transform = "translateX(" + diff / (this.ratio * 0.85) + "px)";

      cardImage.style.transform = "translateX(" + diff / (this.ratio * 0.35) + "px)";
    };

    var slider = new Slider();
  }
})();
